module.exports = __webpack_public_path__ + "static/media/EVC-fan.6fce3ddd.png";